import { render, staticRenderFns } from "./UpdateAvatarModal.vue?vue&type=template&id=584fe440&scoped=true&lang=pug"
import script from "./UpdateAvatarModal.vue?vue&type=script&lang=js"
export * from "./UpdateAvatarModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAvatarModal.vue?vue&type=style&index=0&id=584fe440&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584fe440",
  null
  
)

export default component.exports